import React, { useState } from 'react';
import { ChevronDownIcon } from 'lucide-react';
interface Props {
  activeTab: string;
  onTabChange: (tab: string) => void;
  spaceName: string;
}
export const KnowledgeSpaceHeader = ({
  activeTab,
  onTabChange,
  spaceName
}: Props) => {
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);
  const tabs = [{
    id: 'overview',
    label: 'Overview'
  }, {
    id: 'documents',
    label: 'Documents & Data'
  }, {
    id: 'chatbots',
    label: 'Chatbots'
  }, {
    id: 'apis',
    label: 'External APIs'
  }, {
    id: 'settings',
    label: 'Settings'
  }];
  // Find active tab label
  const activeTabLabel = tabs.find(tab => tab.id === activeTab)?.label;
  return <div className="px-2 sm:px-4" data-id="element-1192">
      <h1 className="text-lg sm:text-2xl font-medium text-white font-mono uppercase tracking-wide mb-4 sm:mb-6" data-id="element-1193">
        {spaceName}
      </h1>
      {/* Mobile Dropdown */}
      <div className="sm:hidden" data-id="element-1194">
        <button onClick={() => setIsMobileMenuOpen(!isMobileMenuOpen)} className="w-full flex items-center justify-between px-3 py-2 bg-surface-light 
                   border border-surface-border text-white rounded-none" data-id="element-1195">
          <span className="font-mono text-sm uppercase tracking-wide" data-id="element-1196">
            {activeTabLabel}
          </span>
          <ChevronDownIcon size={16} className={`transform transition-transform duration-200 ${isMobileMenuOpen ? 'rotate-180' : ''}`} data-id="element-1197" />
        </button>
        {isMobileMenuOpen && <div className="absolute left-0 right-0 mt-1 bg-surface-light border-x border-b 
                       border-surface-border z-20 animate-in slide-in-from-top-2" data-id="element-1198">
            {tabs.map(tab => <button key={tab.id} onClick={() => {
          onTabChange(tab.id);
          setIsMobileMenuOpen(false);
        }} className={`
                  w-full px-4 py-3 text-left text-sm font-mono uppercase tracking-wide transition-colors
                  ${activeTab === tab.id ? 'text-accent-light bg-surface' : 'text-gray-400 hover:text-gray-300'}
                `} data-id="element-1199">
                {tab.label}
              </button>)}
          </div>}
      </div>
      {/* Desktop Tabs */}
      <div className="hidden sm:flex space-x-1 border-b border-surface-border" data-id="element-1200">
        {tabs.map(tab => <button key={tab.id} onClick={() => onTabChange(tab.id)} className={`
              relative py-3 px-4 text-sm font-mono uppercase tracking-wide transition-colors
              ${activeTab === tab.id ? 'text-accent-light' : 'text-gray-400 hover:text-gray-300'}
            `} data-id="element-1201">
            {tab.label}
            <div className={`
                absolute bottom-0 left-0 right-0 h-0.5 bg-accent
                transition-all duration-200 ease-out
                ${activeTab === tab.id ? 'opacity-100 scale-x-100' : 'opacity-0 scale-x-0'}
              `} data-id="element-1202" />
          </button>)}
      </div>
    </div>;
};